import { render, staticRenderFns } from "./UpdateCustomerProductOrderPopUp.vue?vue&type=template&id=6e655b7a&scoped=true&"
import script from "./UpdateCustomerProductOrderPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerProductOrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerProductOrderPopUp.vue?vue&type=style&index=0&id=6e655b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e655b7a",
  null
  
)

export default component.exports